import { HttpGet, HttpPost, HttpPost2 } from "../../utils/lib/api.request.js";
import {
  randomWord,
  getTimeStamp,
  tempLoginSign,
  loginSign,
} from "../../utils/lib/sign";
import baseConfig from "../../../public/config.json";

// 获取文件夹总共目录
export const reqGetAllDocs = (data) => {
  return HttpGet("/api/public/cloud/uploaddir/gettree1", data);
};
// 绑定手机号
export const reqBindPhone = (bodyJson) =>
  HttpPost("/api/public/security/user/bindmobile", bodyJson);

// 查询专属行业信息
export const reqIndustryList = () =>
  HttpGet("/api/public/wxgzh/findindustry");

// 修改通知状态new
export const reqUpdateNotice = (bodyJson) =>
  HttpPost("/api/public/security/user/updatenotice", bodyJson);

// 手机号注册new
export const reqPhoneReg = (bodyJson) =>
  HttpPost("/api/public/security/user/v2/reg", bodyJson);

// 微信注册new
export const reqWxReg = (bodyJson) =>
  HttpPost("/api/public/oauth2/wx/v3/reglogin", bodyJson);

// 重置已绑定的微信
export const reqResetWx = (bodyJson) =>
  HttpPost("/api/public/security/user/resetboundwechat", bodyJson);

// 商城接口
// 获取获取产品展示
export const reqGetProductLists = () => HttpGet("/api/public/mall/productlist");
// 获取产品优惠列表
export const reqGetProductDiscount = (params) =>
  HttpGet("/api/public/mall/productdiscount/" + params);
// 支付-主套餐
export const reqPostProduceOrder = (bodyJson) =>
  HttpPost("/api/public/mall/postproductorder", bodyJson);
// 查询订单支付状态
export const reqGetCheckOrderPayStatus = (params) =>
  HttpGet("/api/public/mall/checkorderpaystatus/" + params);
// 获取扩展功能包
export const reqGetExtFunctionList = (productcode, masterorderid) =>
  HttpGet(
    "/api/public/mall/extfunctionlist/" + productcode + "/" + masterorderid
  );
// 提交扩展功能订单-VIP升级包支付
export const reqPostFunctionOrder = (bodyJson) =>
  HttpPost("/api/public/mall/postfunctionorder", bodyJson);
// 获取订单列表
export const reqGetOrderLists = () => HttpGet("/api/public/mall/getorderlist");
// 获取已订购的产品列表
export const reqGetUserProduct = () =>
  HttpGet("/api/public/mall/getuserproduct");
// 获取已订购的功能列表
export const reqGetUserFunction = () =>
  HttpGet("/api/public/mall/getuserfunction");
// 验证扩展功能订单并计算优惠
export const reqPostFunctionOrderAndCaleDiscount = (bodyJson) =>
  HttpPost("/api/public/mall/checkfunctionorderandcalediscount", bodyJson);
// 重新获取权限
export const reqGetPremission = () =>
  HttpGet("/api/public/security/user/getpremission");
// 会员等级包续费  主套餐续费  续费按钮
export const reqPostProductContinueOrder = (bodyJson) =>
  HttpPost("/api/public/mall/postproductcontinueorder", bodyJson);

// 获取发票 header
export const getInvoiceHeader = () =>
  HttpGet("/api/public/mall/getinvoiceheader");

// 获取合同相关信息
export const reqGetContractinfo = (orderid) =>
  HttpGet("/api/public/mall/contractinfo/" + orderid);

// 计算优惠码和运营商编码优惠信息
export const reqCaleCouponCodeAndAgentCode = (bodyJson) =>
  HttpPost("/api/public/mall/calecouponcodeandagentcode", bodyJson);

// 修改密码
export const reqUpdatePwd = (bodyJson) =>
  HttpPost("/api/public/security/user/updatepwd", bodyJson);

// 获取订单发票列表
export const reqGetOrderInvoiceList = () =>
  HttpGet("/api/public/mall/getorderinvoicelist");
// 获取订单合同列表
export const getOrderContractList = () =>
  HttpGet("/api/public/mall/getordercontractlist");

// 获取上传文件库自定义个数
export const getCustomNumber = () =>
  HttpGet("/api/public/uploaddir/getcustomnumber");

//获取最新文件(法规分类)
export const reqGetLasFiles = (params, nodes) =>
  HttpPost("/api/public/search/new", params, nodes);

// 文件列表的详情页面
export const reqPostDocDetail = (bodyJson) =>
  HttpPost("/api/public/search/showdoc", bodyJson);

//用户临时登录
export const reqTempLogin = () => {
  var randomStr, timestamp, sign, password;
  randomStr = randomWord(true, 10, 16);
  timestamp = getTimeStamp();
  password = baseConfig.tempLoginPwd;
  sign = tempLoginSign(timestamp, randomStr, password);
  var bodyJson = {
    randstr: randomStr,
    timestamp: timestamp,
    sign: sign,
  };
  return HttpPost2("/api/public/login/tempuser", bodyJson);
};

//根据id获取一键上传进度V2
export const reqGetOneKey_UploadProgress_V2 = (identity) =>
  HttpGet("/api/public/cloud/upload/onekey_speed_v2/" + identity);

//用户账号登录
export const reqLogin = (payload) => {
  var randomStr;
  var timestamp;
  var sign;
  randomStr = randomWord(true, 6, 8);
  timestamp = getTimeStamp();
  sign = loginSign(payload.userid, timestamp, randomStr, payload.passwd);
  var bodyJson = {
    userid: payload.userid,
    tempuserguid: payload.tempid,
    randstr: randomStr,
    timestamp: timestamp,
    sign: sign,
  };
  return HttpPost2("/api/public/login/user", bodyJson);
};

//修改手机号码
export const reqMobileUpdate = (bodyJson) =>
  HttpPost("/api/public/security/user/mobileupdate", bodyJson);

//用户手机验证码登录
export const reqSMSLogin = (payload) => {
  var bodyJson = {
    mobilenum: payload.mobilenum,
    tempuserguid: payload.tempid,
    smscode: payload.smscode,
  };
  return HttpPost2("/api/public/login/mobile", bodyJson);
};

//用户注册
export const reqReg = (reginfo) => {
  var bodyJson = {
    mobilenum: reginfo.mobilenum,
    userid: reginfo.userid,
    pwd: reginfo.password,
    tempuserguid: reginfo.tempuserguid,
    smscode: reginfo.smscode,
    workunit: reginfo.unitname,
    login: true,
  };
  return HttpPost("/api/public/security/user/reg", bodyJson);
};

//获取验证码
export const reqSmsCode = (bodyJson) => {
  console.log("bodyJson", bodyJson);
  return HttpPost("/api/public/security/user/getsmscode", bodyJson);
};

//验证验证码
export const reqRegCheckSmsCode = (telnum, smscode, codetype) => {
  var bodyJson = {
    mobilenum: telnum,
    smscode: smscode,
    smscodetype: codetype,
  };
  return HttpPost("/api/public/security/user/checksmscode", bodyJson);
};

// 当登录结果的rltcode==-3时，需要激活
export const reqMobileActive = (bodyJson) =>
  HttpPost("/api/public/security/user/active", bodyJson);

//修改密码
export const reqSetPwd = (telnum, pwd, smscode) => {
  var bodyJson = {
    mobilenum: telnum,
    pwd: pwd,
    smscode: smscode,
  };
  return HttpPost("/api/public/security/user/resetpwd", bodyJson);
};

//校验用户ID是否有效
export const reqCheckUserId = (telnum, userId) => {
  var bodyJson = {
    mobilenum: telnum,
    expectuserid: userId,
  };
  return HttpPost("/api/public/security/user/checkid", bodyJson);
};

// 更新token
export const refreshToken = (nodes) => {
  var bodyJson = {};
  return HttpPost("/api/public/security/user/refreshtoken", bodyJson, nodes);
};

//意见和建议(意见反馈)
export const reqCreateFeedBack = (args) => {
  var bodyJson = {
    suggestions: args.suggestions,
  };
  return HttpPost("/api/public/suggestions/suggestions/add", bodyJson);
};

// 综合检索
export const reqGetGeneralFiles = (args, nodes) =>
  HttpPost("/api/public/search/engine/general", args, nodes);

// 进出口税收检索
export const reqGetInOutFiles = (args, nodes) =>
  HttpPost("/api/public/search/engine/inout", args, nodes);

// 税收优惠项目
export const reqGetTaxBreakFiles_item = (args, nodes) =>
  HttpPost("/api/public/search/engine/reduction_item", args, nodes);

// 税收优惠税种
export const reqGetTaxBreakFiles_taxes = (args, nodes) =>
  HttpPost("/api/public/search/engine/reduction_taxes", args, nodes);

// 税收优惠行业
// 税收优惠行业通用
export const reqGetTaxBreakIndustryCommonFiles = (args, nodes) =>
  HttpPost("/api/public/search/engine/reduction_industrycommon", args, nodes);

// 税收优惠行业专属
export const reqGetTaxBreakIndustryFiles = (args, nodes) =>
  HttpPost("/api/public/search/engine/reduction_industry", args, nodes);

//行业检索,专属
export const reqGetIndustryFiles = (args, nodes) =>
  HttpPost("/api/public/search/engine/industry", args, nodes);

//行业检索,通用
export const reqGetIndustryCommonFiles = (args, nodes) =>
  HttpPost("/api/public/search/engine/industrycommon", args, nodes);

// 条约检索 国家(地区)
export const reqGetTreatyFiles = (args, nodes) =>
  HttpPost("/api/public/search/engine/treaty", args, nodes);

// 条约检索 通用规定
export const reqGetCommonTreatyFiles = (args, nodes) =>
  HttpPost("/api/public/search/engine/treatycommon", args, nodes);

// 行业
export const reqGetIndustry = () => {
  var params = {};
  return HttpGet("/api/public/base/industry", params);
};

// 税种
export const reqGetTaxes = () => {
  var params = {};
  return HttpGet("/api/public/base/taxes", params);
};

// 进出口
export const reqGetInOut = () => {
  var params = {};
  return HttpGet("/api/public/base/inout", params);
};

// 优惠项目
export const reqGetReduction = () => {
  var params = {};
  return HttpGet("/api/public/base/reduction_item", params);
};

// 优惠税种
export const reqGetReduction_tax = () => {
  var params = {};
  return HttpGet("/api/public/base/reduction_taxes", params);
};

// 优惠行业
export const reqGetReduction_industry = () => {
  var params = {};
  return HttpGet("/api/public/base/reduction_industry", params);
};

// 获取国家
export const reqGetCountry = () => {
  var params = {};
  return HttpGet("/api/public/base/country", params);
};

// 文件夹创建默认目录
export const reqCreateDefault = () => {
  var bodyJson = {};
  return HttpPost("/api/public/cloud/uploaddir/createdefault", bodyJson);
};

// 获取文件夹固定目录
export const reqGetFixedFolder = () => {
  var parameters = {};
  return HttpGet("/api/public/cloud/uploaddir/getfixed", parameters);
};

//new获取文件库目录树,按父级目录id
export const reqGetTreeByParentId = (args) => {
  var parameters = {};
  parameters.sdirid = args.sdirid;
  return HttpGet("/api/public/cloud/uploaddir/gettree", parameters);
};

// new创建文件夹
export const reqCreateNewDoc = (data) => {
  return HttpPost("/api/public/cloud/uploaddir/create", data);
};

// new删除文件夹及子文件夹
export const reqRemoveDoc = (data) => {
  return HttpPost("/api/public/cloud/uploaddir/remove", data);
};

// new文件夹改名
export const reqRenameDoc = (data) => {
  return HttpPost("/api/public/cloud/uploaddir/rename", data);
};

// 移动文件夹
export const reqMoveDoc = (data) => {
  return HttpPost("/api/public/cloud/uploaddir/move", data);
};

// 获取文件库目录列表,按父级目录id
export const reqGetChildByParentId = (args) => {
  var parameters = {};
  parameters.sdirid = args.sdirid;
  return HttpGet("/api/public/cloud/uploaddir/getchild", parameters);
};

//获取云端文件
export const reqGetUploadFiles = (args) =>
  HttpPost("/api/public/cloud/upload/searchallfile", args);

//上传文件至云端,选择性上传[1,2]
export const upLoadFileToCloud = (idlist, folderid) => {
  var bodyJson = {
    dirid: folderid,
    docids: idlist,
  };
  return HttpPost("/api/public/cloud/upload/add", bodyJson);
};

//删除云端指定文件夹下的文件
export const reqRemoveFilesByFolderId = (folderid) => {
  var bodyJson = {
    dirid: folderid,
  };
  return HttpPost("/api/public/cloud/upload/clean", bodyJson);
};

//删除云端文件夹文件,按文件id
export const reqRemoveFilesByList = (folderid, list) => {
  var bodyJson = {
    dirid: folderid,
    docids: list,
  };
  return HttpPost("/api/public/cloud/upload/remove", bodyJson);
};

//删除云端指定文件夹下的全文废止(失效)文件
export const reqRemoveAbolitionFilesByFolderId = (folderid) => {
  var bodyJson = {
    dirid: folderid,
  };
  return HttpPost("/api/public/cloud/upload/removeabolition", bodyJson);
};

// 一键上传-最新文件
export const reqOneKeyLastFiles = (args) =>
  HttpPost("/api/public/cloud/upload/onekey_v2/new", args);

// 一键上传-综合搜索
export const reqOneKeyGeneralFiles_V2 = (args) =>
  HttpPost("/api/public/cloud/upload/onekey_v2/general", args);

// 一键上传-进出口
export const reqOneKeyInoutFiles_V2 = (args) =>
  HttpPost("/api/public/cloud/upload/onekey_v2/inout", args);

// 一键上传-行业-通用
export const reqOneKeyIndustryCommonFiles_V2 = (args) =>
  HttpPost("/api/public/cloud/upload/onekey_v2/industrycommon", args);

// 一键上传-行业-专属
export const reqOneKeyIndustrySpecialFiles_V2 = (args) =>
  HttpPost("/api/public/cloud/upload/onekey_v2/industry", args);

// 一键上传-条约-通用
export const reqOneKeyTreatyCommonFiles_V2 = (args) =>
  HttpPost("/api/public/cloud/upload/onekey_v2/treatycommon", args);

// 一键上传-条约-专属
export const reqOneKeyTreatySpecialFiles_V2 = (args) =>
  HttpPost("/api/public/cloud/upload/onekey_v2/treaty", args);

// 一键上传-税收优惠项目
export const reqOneKeyTaxBreakFiles_item_V2 = (args) =>
  HttpPost("/api/public/cloud/upload/onekey_v2/reduction_item", args);

// 一键上传-税收优惠税种
export const reqOneKeyTaxBreakFiles_taxes_V2 = (args) =>
  HttpPost("/api/public/cloud/upload/onekey_v2/reduction_taxes", args);

// 一键上传-税收优惠行业通用
export const reqOneKeyTaxBreakFiles_common_V2 = (args) =>
  HttpPost("/api/public/cloud/upload/onekey_v2/reduction_industrycommon", args);

// 一键上传-税收优惠行业专属
export const reqOneKeyTaxBreakFiles_special_V2 = (args) =>
  HttpPost("/api/public/cloud/upload/onekey_v2/reduction_industry", args);

// 请求地方版默认数据
export const reqGetLocalLastFiles = (params, nodes) =>
  HttpPost("/api/public/search/localnew", params, nodes);

// 获取定位
export const ReqGetLocation = (x = 0, y = 0) => {
  var params = {};
  return HttpGet(`/api/public/base/postion_v2?x=${x}&y=${y}`, params);
};

// 获取wx的options
export const reqGetWxConfig = (reqBody) =>
  HttpPost("/api/public/oauth2/wx/getconfig", reqBody);

// 获取省市
export const reqGetProvinceAndCity = () => {
  var params = {};
  return HttpGet("/api/public/base/division", params);
};

//地方版一键上传
export const reqOneKeyLocalUpload_V2 = (args) =>
  HttpPost("/api/public/cloud/upload/onekey_v2/new", args);

// 获取微信授权
export const reqPostGetWeixinPromise = (req) =>
  HttpPost("/api/public/oauth2/wx/requrl", req);

// 扫描PC端二维码确认登录提交code和state
export const reqPostScanToLogin = (req) =>
  HttpPost("/api/public/oauth2/wx/postcodeandstate", req);

// 扫描PC端二维码之后立刻传递id和model给后端
export const reqPostScanned = (req) =>
  HttpPost("/api/public/oauth2/wx/scanned", req);

// 扫描PC端二维码之后微信端取消授权
export const reqPostCloseAuth = (req) =>
  HttpPost("/api/public/oauth2/wx/closeauth", req);

// 微信授权登录
export const reqPostWeixinLogin = (req) =>
  HttpPost("/api/public/oauth2/wx/login", req);

// 微信注册登录
export const reqPostWeixinRegLogin = (req) =>
  HttpPost("/api/public/oauth2/wx/reglogin", req);
// 微信注册登录2
export const reqPostWeixinRegLogin2 = (req) =>
  HttpPost("/api/public/oauth2/wx/reglogin2", req);

// 微信登录之后创建账号
export const reqPostWeixinCreateUser = (req) =>
  HttpPost("/api/public/oauth2/wx/createuserid", req);

// 微信登录之后创建账号new
export const reqPostWeixinUpdateUser = (req) =>
  HttpPost("/api/public/security/user/updateuserid", req);

// 微信登录之后请求验证码
export const reqPostWeixinUpdateUserId = (req) =>
  HttpPost("/api/public/oauth2/wx/wxupdateuserid", req);

// 微信登录后绑定账号
export const reqPostWeixinBindUser = (req) =>
  HttpPost("/api/public/oauth2/wx/binduser", req);

// 用户登录后关联微信
export const reqPostWeixinUserBind = (req) =>
  HttpPost("/api/public/oauth2/wx/userbind", req);

// 虚拟登录
export const reqPostWeixinVitrulLogin = (req) =>
  HttpPost("/api/public/oauth2/wx/virtuallogin", req);

// 微信内用户登录
export const reqPostWeixinGetWxId = (req) =>
  HttpPost("/api/public/oauth2/wx/getwxid", req);

// 发票发送到邮箱
export const sendInvoiceToEmailOrPhone = (req) =>
  HttpPost("api/public/mall/invoicesend", req);

// 发票重开
export const reqInvoiceChange = (req) =>
  HttpPost("/api/public/mall/reqinvoicechange", req);

// 开具发票
export const sureReqInvoice = (req) =>
  HttpPost("/api/public/mall/reqinvoice", req);

// 关闭文件时
export const reqCloseDoc = (req) =>
  HttpPost("/api/public/search/closedoc", { strdocids: req });

// 一键上传验证
export const reqCheckPremission = (req) =>
  HttpPost("/api/public/security/user/checkpremission", req);

// 获取分享链接
export const reqGetShareUrl = (req) =>
  HttpPost("/api/public/share/geturl", req);

// 解析分享码
export const reqParseShareCode = (req) =>
  HttpPost("/api/public/share/parsecode", req);

// 打开分享文档
export const reqOpenDoc = (req) =>
  HttpPost("/api/public/share/showdoc", req);

// 获取推广链接
export const reqSpreadLink = (req) =>
  HttpPost("/api/public/security/user/getspreadlink", req);

// 绑定金管家
export const reqBindjgj = (req) =>
  HttpPost("/api/public/security/user/bindjgjcode", req);

// 获取推广用户列表
export const reqGetMyCustomers = (req) => {
  var params = {
    page: req.page,
    line: req.line
  };
  return HttpGet("/api/public/security/user/getspreaduser", params)
}

// 获取法院信息
export const reqGetCourt = () =>
  HttpGet("/api/public/base/court");

// 获取税务分类信息
export const reqGetTaxClassify = () =>
  HttpGet("/api/public/base/taxnews")

// 获取涉税判例分类信息
export const reqGetjudgeType = () =>
  HttpGet("/api/public/base/paperword");

// 获取文件tts语音
export const ReqGetTTs = (strdocid) => {
  var params = {};
  return HttpGet(`/api/public/search/tts/${strdocid}`, params)
}
// 分享计算次数
export const reqCalculateNum = (req) =>
  HttpPost("/api/public/share/sharesuccess", req);

// 发送邮件
export const reqSendMail = (req) =>
  HttpPost("/api/public/search/email", req);

// 获取税务分类信息
export const reqGetTree = () =>
  HttpGet("/api/public/base/defaultlefttree")

// 优惠匹配
export const reqMatching = (req) =>
  HttpPost("/api/public/search/matchfile", req);


//用户临时登录
export const reqMatchUser = () => {
  var randomStr, timestamp, sign, password;
  randomStr = randomWord(true, 10, 16);
  timestamp = getTimeStamp();
  password = baseConfig.tempLoginPwd;
  sign = tempLoginSign(timestamp, randomStr, password);
  var bodyJson = {
    randstr: randomStr,
    timestamp: timestamp,
    sign: sign,
  };
  return HttpPost2("/api/public/login/matchuser", bodyJson);
};

// chat history
export const reqChatHistory = (req) =>
  HttpPost("/api/public/search/findchathistory", req);
// view someone history
export const reqChatHistoryView = (req) =>
  HttpPost("/api/public/search/getchathistorydetail", req);
// delete someone history
export const reqDeleteOneHistoryRec = (req) =>
  HttpPost("/api/public/search/delchathistory", req);